import {
    SET_LOAN_TERM,
    SET_LOAN_INTEREST,
    SET_DOWN_PAYMENT,
    SET_MOSAIC_TERM,
    SET_MOSAIC_DOWN_PAYMENT,
    SET_LOAN_PROVIDER,
    SET_SHOW_LOAN,
    SET_LOAN,
} from './constants';

const defaultState = {
    downPayment: 0,
    loanTerm: 84,
    interest: 6,
    mosaicTerm: 240,
    mosaicDownPayment: 0,
    loanProvider: 'mosaic',
    showLoan: false,
    mosaicFee: 1.12,
};

const loan = (state = defaultState, action) => {
    switch (action.type) {
        case SET_LOAN:
            return {
                ...state,
                mosaicTerm: action.loan.mosaicTerm,
                mosaicDownPayment: action.loan.mosaicDownPayment,
                downPayment: action.loan.downPayment,
                interest: action.loan.rate,
                loanTerm: action.loan.termInMonths,
                loanProvider: action.loan.loanType,
                showLoan: action.loan.showLoan,
            };
        case SET_DOWN_PAYMENT:
            return { ...state, downPayment: action.downPayment };

        case SET_LOAN_INTEREST:
            return { ...state, interest: action.interest };

        case SET_LOAN_TERM:
            return { ...state, loanTerm: action.loanTerm };

        case SET_MOSAIC_TERM:
            return { ...state, mosaicTerm: action.mosaicTerm };

        case SET_MOSAIC_DOWN_PAYMENT:
            return { ...state, mosaicDownPayment: action.mosaicDownPayment };

        case SET_LOAN_PROVIDER:
            return { ...state, loanProvider: action.loanProvider };

        case SET_SHOW_LOAN:
            return { ...state, showLoan: action.showLoan };


        default:
            return state;
    }
};

export default loan;



// WEBPACK FOOTER //
// ./src/containers/common/loan/reducer.js